import React from "react";
import { useHistory } from "react-router-dom";
import RoutePath from "../../RoutePath";
import { editReport } from "./Constants";
import { Reports } from "./Reports";
import { ButtonComponent } from "./SubComponents";

export const EditReport = () => {
  const history = useHistory();

  const onBackHandler = () => {
    if (history) history.push(RoutePath.home);
  };

  const onDeleteHandler = () => {
    // if (history) history.push(RoutePath.home); // will do api call
  };

  const onSaveHandler = () => {
    alert("Save");
  };

  const onClickHandler = (btnType = "") => {
    if (btnType == "cancel") {
      alert("cancel");
    } else if (btnType == "delete") {
      alert("delete");
    }
  };
  const addReportValues = {
    isEdit: true,
    data: editReport,
    onBack: onBackHandler,
    onDelete: onDeleteHandler,
    onSave: onSaveHandler,
  };

  return (
    <>
      <Reports {...addReportValues} />
      <div
        className="modal fade"
        id="delete"
        tabIndex="-1"
        aria-labelledby="deleteLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteLabel">
                Delete Report
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ><span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body">
              Are you sure you want to delete the report?
            </div>
            <div className="modal-footer">
              <ButtonComponent
                title="Cancel"
                data-bs-dismiss="modal"
                onClickHandler={() => onClickHandler("cancel")}

              />
              <ButtonComponent title="Delete"
                onClickHandler={() => onClickHandler("delete")}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
